<template>
  <div>
    <h1 class="text-red-600">Component test</h1>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "default",
});
</script>
